import { reservationLocalHost } from '@/model/dataLayer/api/newReservation/reservation'
import { hillo } from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

const url = reservationLocalHost + '/settings/priceCombo/'

export async function getPriceCombo () {
  return (await hillo.get(url + await getCurrentDeviceId(), {})).data
}

/**
 * 全部套餐（含带生效日期的）。
 * 后端还没有 /all 接口时（老版本回 404），退回老接口，supportsEffectiveDate = false：
 * 这时老接口不认识生效日期，页面不让填日期，免得填了保存后被悄悄丢掉。
 * @return {Promise<{list: Array, supportsEffectiveDate: boolean}>}
 */
export async function getAllPriceCombo () {
  const deviceId = await getCurrentDeviceId()
  const res = await hillo.silentGet(url + deviceId + '/all', {})
  if (res?.code === 200 && Array.isArray(res.data)) {
    return { list: res.data, supportsEffectiveDate: true }
  }
  return { list: (await getPriceCombo()) ?? [], supportsEffectiveDate: false }
}

export async function savePriceCombo (item) {
  return (await hillo.jsonPost(url + 'addOrUpdate', {
    ...item,
    deviceId: await getCurrentDeviceId()
  }))
}

export async function deletePriceCombo (id) {
  return (await hillo.post(url + id + '/delete', {}))
}
